import React, { useContext } from "react"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { CogIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { AuthContext } from "../../context/auth.context"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import { validateYup } from "../template-info/templateUtils"
import * as yup from "yup"
import { Header } from "../common/header"
import Select from "../atoms/select.atom"
import { getCookie } from "../../helper/auth"

export const AddConfig = ({ hubId, onAddConfig }) => {
	const { auth } = useContext(AuthContext)
	const [form, setForm] = React.useState({
		userId: "",
		password: "",
		contentType: "",
		DLTEntityId: "",
		name: ""
	})
	const [loading, setLoading] = React.useState(false)
	const [errors, setErrors] = React.useState({})

	const getDLTEntityId = () => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.hubAppConfigDLTEntityId, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			setForm({ DLTEntityId: res.data.data[0]?.dltentityId })
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const addAppConfig = () => {
		let schema = yup.object().shape({
			userId: yup.string().trim().required("Required"),
			password: yup.string().trim().required("Required"),
			name: yup
				.string()
				.trim()
				.required("Required")
				.matches(
					/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
					"Only alphabets are allowed for this field "
				),
			DLTEntityId: yup.string().trim(),
			contentType: yup.string().trim().required("Required")
		})
		validateYup(schema, form)
			.then(() => {
				setErrors({})
				setLoading(true)
				;(async () => {
					const token = getCookie("token")
					await axiosInstance.post(
						EndpointConfig.hubAppConfig,
						{
							userId: form.userId,
							password: form.password,
							DLTEntityId: form.DLTEntityId,
							contentType: form.contentType,
							name: form.name
						},
						{
							headers: {
								Authorization: `Bearer ${token}`
							}
						}
					)
					toast("Added Successfully")
					setForm({
						userId: "",
						password: "",
						contentType: "",
						DLTEntityId: "",
						name: ""
					})
					onAddConfig?.()
				})()
					.catch(console.err)
					.finally(() => setLoading(false))
			})
			.catch(setErrors)
	}

	React.useEffect(() => {
		getDLTEntityId()
	}, [])

	return (
		<div className="flex flex-col">
			<Header IconName={CogIcon} subText={"Setup"} mainText={"Add SMS Configurations"} />
			<div className="flex flex-col gap-1 p-4 bg-white rounded">
				<div className="flex flex-row gap-6">
					<Input
						name="name"
						error={errors?.name}
						value={form.name}
						label={"Record Name"}
						placeholder={"SMS Config - 1"}
						onChange={(e) => setForm({ ...form, name: e.target.value })}
					/>
					<Input
						name="DLTEntityId"
						disabled={true}
						error={errors?.DLTEntityId}
						value={form.DLTEntityId}
						label={"DLT Entity Id"}
						placeholder={"DLT Entity Id"}
						onChange={(e) => setForm({ ...form, DLTEntityId: e.target.value })}
					/>
					{/* <Input name='contentType' error={errors?.contentType}
                        value={form.contentType}
                        label={'Content Type'} placeholder={'Content Type'}
                        onChange={(e) => setForm({ ...form, contentType: e.target.value })}
                    /> */}
					<Select
						placeholder={"Content Type"}
						error={errors?.contentType}
						label="Content Type"
						selectedValue={{ label: form.contentType, value: form.contentType }}
						// valueRendered={(selectedValue) => selectedValue.userId}
						onSelect={({ value }) => {
							setForm({ ...form, contentType: value })
						}}
						options={[
							"Service Implicit",
							"Service Explicit",
							"Transactional",
							"Promotional"
						].map((ob) => ({ label: ob, value: ob }))}
					/>
				</div>
				<div className="flex flex-row gap-6">
					<Input
						name="userId"
						error={errors?.userId}
						value={form.userId}
						label={"User Id"}
						placeholder={"User Id"}
						onChange={(e) => setForm({ ...form, userId: e.target.value })}
					/>
					<Input
						name="password"
						error={errors?.password}
						value={form.password}
						label={"Password"}
						placeholder={"Password"}
						onChange={(e) => setForm({ ...form, password: e.target.value })}
					/>
				</div>
				<div className="flex flex-row gap-6">
					<div className="flex-[3]">&nbsp;</div>
					<div className="flex-1">
						&nbsp;
						{loading ? (
							<Button className="w-full text-black bg-red-100 pointer-events-none ">
								Loading
							</Button>
						) : (
							<Button className="w-full " onClick={addAppConfig}>
								Add
							</Button>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
